import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import API from "../api";

export default function Login() {
  const [step, setStep] = useState("login");
  const [form, setForm] = useState({ email: "", password: "", otp: "", newPassword: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleChange = e => setForm(p => ({ ...p, [e.target.name]: e.target.value }));

  const handleLogin = async e => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res = await API.post("/auth/login", { email: form.email, password: form.password });
      login(res.data.user, res.data.token);
      navigate("/app/dashboard");
    } catch (err) {
      setError(err.response?.data?.error || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  const handleForgot = async e => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await API.post("/auth/forgot-password", { email: form.email });
      setSuccess("OTP email pe bhej diya!");
      setStep("otp");
    } catch (err) {
      setError(err.response?.data?.error || "Failed");
    } finally {
      setLoading(false);
    }
  };

  const handleReset = async e => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await API.post("/auth/reset-password", {
        email: form.email,
        otp: form.otp,
        newPassword: form.newPassword
      });
      setSuccess("Password reset ho gaya! Login karein.");
      setStep("login");
    } catch (err) {
      setError(err.response?.data?.error || "Failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={s.wrapper}>
      <div style={s.card}>

        <div style={s.logo}>
          <span style={s.logoIcon}>⬡</span>
          <div>
            <div style={s.logoText}>BotSaathi</div>
            <div style={s.logoSub}>WhatsApp Automation Platform</div>
          </div>
        </div>

        {step === "login" && (
          <form onSubmit={handleLogin} style={s.form}>
            <div style={s.title}>Welcome Back</div>
            <div style={s.subtitle}>Apne account mein login karein</div>

            {error && <div style={s.error}>{error}</div>}

            <div style={s.field}>
              <label style={s.label}>Email</label>
              <input name="email" type="email" value={form.email} onChange={handleChange}
                placeholder="admin@botsaathi.com" required style={s.input}
                onFocus={e => e.target.style.borderColor = "var(--accent)"}
                onBlur={e => e.target.style.borderColor = "var(--border)"} />
            </div>

            <div style={s.field}>
              <label style={s.label}>Password</label>
              <input name="password" type="password" value={form.password} onChange={handleChange}
                placeholder="••••••••" required style={s.input}
                onFocus={e => e.target.style.borderColor = "var(--accent)"}
                onBlur={e => e.target.style.borderColor = "var(--border)"} />
            </div>

            <button type="submit" disabled={loading} style={s.btn}>
              {loading ? "Logging in..." : "Login →"}
            </button>

            <div style={s.forgotLink} onClick={() => { setStep("forgot"); setError(""); }}>
              Forget Password
            </div>

            <div style={{ textAlign: "center", fontSize: 13, color: "var(--text-muted)" }}>
              New here?{" "}
              <Link to="/signup" style={{ color: "var(--accent)", textDecoration: "none" }}>
                Create account →
              </Link>
            </div>
          </form>
        )}

        {step === "forgot" && (
          <form onSubmit={handleForgot} style={s.form}>
            <div style={s.title}>Password Reset</div>
            <div style={s.subtitle}>Email pe OTP bhejenge</div>

            {error && <div style={s.error}>{error}</div>}
            {success && <div style={s.successMsg}>{success}</div>}

            <div style={s.field}>
              <label style={s.label}>Email</label>
              <input name="email" type="email" value={form.email} onChange={handleChange}
                placeholder="aapka@email.com" required style={s.input}
                onFocus={e => e.target.style.borderColor = "var(--accent)"}
                onBlur={e => e.target.style.borderColor = "var(--border)"} />
            </div>

            <button type="submit" disabled={loading} style={s.btn}>
              {loading ? "Sending..." : "OTP Bhejo"}
            </button>

            <div style={s.forgotLink} onClick={() => { setStep("login"); setError(""); }}>
              ← Wapas Login
            </div>
          </form>
        )}

        {step === "otp" && (
          <form onSubmit={handleReset} style={s.form}>
            <div style={s.title}>New Password Set Karein</div>
            <div style={s.subtitle}>Email pe aaya OTP enter karein</div>

            {error && <div style={s.error}>{error}</div>}
            {success && <div style={s.successMsg}>{success}</div>}

            <div style={s.field}>
              <label style={s.label}>OTP</label>
              <input name="otp" value={form.otp} onChange={handleChange}
                placeholder="6 digit OTP" required style={s.input}
                onFocus={e => e.target.style.borderColor = "var(--accent)"}
                onBlur={e => e.target.style.borderColor = "var(--border)"} />
            </div>

            <div style={s.field}>
              <label style={s.label}>New Password</label>
              <input name="newPassword" type="password" value={form.newPassword} onChange={handleChange}
                placeholder="Naya password" required style={s.input}
                onFocus={e => e.target.style.borderColor = "var(--accent)"}
                onBlur={e => e.target.style.borderColor = "var(--border)"} />
            </div>

            <button type="submit" disabled={loading} style={s.btn}>
              {loading ? "Resetting..." : "Password Reset Karo"}
            </button>
          </form>
        )}

      </div>
    </div>
  );
}

const s = {
  wrapper: {
    minHeight: "100vh", background: "var(--bg-primary)",
    display: "flex", alignItems: "center", justifyContent: "center", padding: 20,
  },
  card: {
    background: "var(--bg-card)", border: "1px solid var(--border)",
    borderRadius: "var(--radius-lg)", padding: "40px",
    width: "100%", maxWidth: 420, boxShadow: "var(--shadow)",
  },
  logo: { display: "flex", alignItems: "center", gap: 12, marginBottom: 32 },
  logoIcon: { fontSize: 32, color: "var(--accent)" },
  logoText: { fontFamily: "var(--font-mono)", fontSize: 18, fontWeight: 700 },
  logoSub: { fontSize: 11, color: "var(--text-muted)", fontFamily: "var(--font-mono)", textTransform: "uppercase", letterSpacing: "0.05em" },
  form: { display: "flex", flexDirection: "column", gap: 16 },
  title: { fontSize: 20, fontWeight: 700, color: "var(--text-primary)" },
  subtitle: { fontSize: 13, color: "var(--text-secondary)", marginTop: -8 },
  field: { display: "flex", flexDirection: "column", gap: 6 },
  label: { fontSize: 12, color: "var(--text-secondary)", fontWeight: 500, textTransform: "uppercase", letterSpacing: "0.05em" },
  input: {
    background: "var(--bg-elevated)", border: "1px solid var(--border)",
    borderRadius: "var(--radius)", padding: "10px 14px",
    color: "var(--text-primary)", fontSize: 14,
    fontFamily: "var(--font-body)", outline: "none", transition: "border-color 0.15s"
  },
  btn: {
    background: "var(--accent)", color: "#000", border: "none",
    borderRadius: "var(--radius)", padding: "12px", fontSize: 14,
    fontWeight: 700, cursor: "pointer", marginTop: 4,
  },
  forgotLink: { textAlign: "center", fontSize: 13, color: "var(--accent)", cursor: "pointer" },
  error: {
    background: "rgba(255,77,77,0.1)", border: "1px solid rgba(255,77,77,0.3)",
    borderRadius: "var(--radius)", padding: "10px 14px",
    color: "var(--accent-red)", fontSize: 13,
  },
  successMsg: {
    background: "rgba(37,211,102,0.1)", border: "1px solid rgba(37,211,102,0.3)",
    borderRadius: "var(--radius)", padding: "10px 14px",
    color: "var(--accent)", fontSize: 13,
  },
};